<template>
  <RouterLink
    :to="to"
    class="group flex flex-col items-center gap-1.5 rounded-sm omr-focus-visible-outline"
    :aria-label="`${label}: ${percentage}%`"
  >
    <span
      class="relative block h-9 w-[72px] transition-transform duration-(--motion-duration-fast) group-hover:-translate-y-0.5 group-focus-visible:-translate-y-0.5"
    >
      <svg class="h-full w-full" viewBox="0 0 64 34" fill="none" aria-hidden="true">
        <path d="M5 31 A27 27 0 0 1 59 31" stroke="#D4D7DC" stroke-width="6" stroke-linecap="round" />
        <path
          d="M5 31 A27 27 0 0 1 59 31"
          stroke="currentColor"
          stroke-width="6"
          stroke-linecap="round"
          class="text-primary-subtle transition-[stroke-dashoffset] duration-(--motion-duration-medium) ease-out"
          :stroke-dasharray="ARC_LENGTH"
          :stroke-dashoffset="offset"
        />
      </svg>
      <span class="absolute inset-x-0 bottom-0 flex justify-center text-label-m text-primary">{{ percentage }}%</span>
    </span>
    <span
      class="text-center text-label-m text-subtle group-hover:text-primary group-hover:underline group-focus-visible:text-primary group-focus-visible:underline"
      >{{ label }}</span
    >
  </RouterLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  percentage: number
  label: string
  to: RouteLocationRaw
}>()

const RADIUS = 27
const ARC_LENGTH = Math.PI * RADIUS

const offset = computed(() => ARC_LENGTH * ((100 - props.percentage) / 100))
</script>
